var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamatory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "#FF9E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.632 11.878H9.288L8.938 5.004H10.982L10.632 11.878ZM8.882 14.104C8.882 13.712 8.98467 13.4367 9.19 13.278C9.39533 13.11 9.652 13.026 9.96 13.026C10.2493 13.026 10.4967 13.1053 10.702 13.264C10.9167 13.4227 11.024 13.7027 11.024 14.104C11.024 14.4867 10.9167 14.762 10.702 14.93C10.4967 15.098 10.2493 15.182 9.96 15.182C9.652 15.182 9.39533 15.098 9.19 14.93C8.98467 14.762 8.882 14.4867 8.882 14.104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamatory);
export default __webpack_public_path__ + "static/media/exclamatory.95e3021da456b7342959c91d641e1c61.svg";
export { ForwardRef as ReactComponent };